import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox, Form, Select } from 'antd';
import { updateV2FormProperties } from '../../stateManager/store/formCreation_v2/actions';
import { Modal } from "../../helpers/commonUi";

interface IProps {
    viewFormProperties: boolean;
    setViewFormProperties: (value: boolean) => void;
}

interface Device {
    name: string;
    resolution: string;
}

type FormWidth = {
    type: string;
    name: string;
    width: string;
}

const defaultFormWidth: FormWidth = {
    type: "MobileDevices",
    name: "Iphone X",
    width: "375"
}

export const SoloFormPropertiesModal = (props: IProps) => {
    const { viewFormProperties, setViewFormProperties } = props;
    const dispatch = useDispatch();
    const formProperties: { formWidth: FormWidth } = useSelector((state: any) => state.formJson.formProperties);
    const { formWidth = defaultFormWidth } = formProperties;
    const [deviceType, setDeviceType] = useState<string>(formWidth.type);
    const [deviceModal, setDeviceModal] = useState<string>(`${formWidth.name}-${formWidth.width}`);

    const { Option } = Select;

    const Devices: Record<string, Device[]> = {
        LargeDevices: [
            { name: 'Desktop Large', resolution: 'Desktop Large-1920' },
            { name: 'Desktop Standard', resolution: 'Desktop Standard-1366' },
            { name: 'Desktop Retina', resolution: 'Desktop Retina-1440' },
            { name: 'Desktop Small', resolution: 'Desktop Small-1280' },
        ],
        TabletDevices: [
            { name: 'Ipad 9', resolution: 'Ipad 9-768' },
            { name: 'Ipad 10', resolution: 'Ipad 10-834' },
            { name: 'Ipad Pro 11', resolution: 'Ipad Pro 11-834' },
            { name: 'Ipad Pro 12', resolution: 'Ipad Pro 12-1024' },
        ],
        MobileDevices: [
            { name: 'Iphone X', resolution: 'Iphone X-375' },
            { name: 'Iphone SE', resolution: 'Iphone SE-375' },
            { name: 'Iphone 13 Pro Max', resolution: 'Iphone 13 Pro Max-428' },
            { name: 'Google Pixel 4', resolution: 'Google Pixel 4-412' },
            { name: 'Google Pixel 4XL', resolution: 'Google Pixel 4XL-412' },
            { name: 'Samsung Galaxy S8', resolution: 'Samsung Galaxy S8-360' },
            { name: 'Samsung Galaxy S20', resolution: 'Samsung Galaxy S20-360' },
            { name: 'Samsung Galaxy S21 Ultra', resolution: 'Samsung Galaxy S21 Ultra-412' },
        ],
    };

    useEffect(() => {
        setDeviceType(formWidth.type);
        setDeviceModal(`${formWidth.name}-${formWidth.width}`);
    }, [formWidth]);

    useEffect(() => {
        const defaultResolution = getDefaultResolution(deviceType, deviceModal);
        if (defaultResolution) {
            setDeviceModal(defaultResolution);
        } else {
            const defaultDevice = Devices[deviceType]?.[0];
            setDeviceModal(defaultDevice ? `${defaultDevice.name}-${defaultDevice.resolution.split('-')[1]}` : '');
        }
    }, [deviceType]);

    const getDefaultResolution = (selectedDeviceType: string, selectedDeviceModalName: string) => {
        const defaultDevice = Devices[selectedDeviceType]?.find(
            (device) => device.name === selectedDeviceModalName
        );

        return defaultDevice ? `${defaultDevice.name}-${defaultDevice.resolution.split('-')[1]}` : '';
    };

    const handleCancel = () => {
        setDeviceType(formWidth.type);
        setDeviceModal(`${formWidth.name}-${formWidth.width}`);
        setViewFormProperties(false);
    };

    const handleOk = () => {
        const name = deviceModal.split('-')[0];
        const width = deviceModal.split('-')[1];
        dispatch(
            updateV2FormProperties({
                ...formProperties,
                formWidth: {
                    type: deviceType,
                    name,
                    width
                }
            })
        );
        setViewFormProperties(false);
    };

    return (
        <Modal
            id='formPropertiesModal'
            dataTestId='formPropertiesModal'
            title="FORM PROPERTIES"
            visible={viewFormProperties}
            onCancel={handleCancel}
            unmountOnCancel={true}
            className='font-bold'
            footer={{
                enable: true,
                okText: 'SUBMIT',
                onOk: handleOk,
                cancelText: 'Cancel'
            }}
        >
            <Form className={'override-content w-full'}>
                <Form.Item
                    label={<span className='text-md font-semibold formProperties_header'>Select Form Width</span>}
                    style={{marginLeft:"14px"}}
                >
                    <div className='font-sans flex flex-row justify-between flex-wrap relative w-471px '>
                        <div className='deviceType flex flex-row w-full gap-4'>
                            <div className=' h-78px flex flex-col justify-evenly w-230px'>
                                <div className='formPropeties_selectLabel my-4 font-normal'>Device Type</div>
                                <Select
                                    className='h-10  w-230px rounded-md text-black font-normal'
                                    style={{color:"black"}}
                                    placeholder='Device Type'
                                    id='deviceType'
                                    onChange={setDeviceType}
                                    value={deviceType}
                                    dropdownClassName='custom-dropdown'
                                >
                                    <Option value='MobileDevices'>Mobile Devices</Option>
                                    <Option value='TabletDevices'>Tablet Devices</Option>
                                    <Option value='LargeDevices'>Large Devices</Option>
                                </Select>
                            </div>
                            <div className='h-78px flex flex-col justify-evenly w-230px'>
                                <div className='formPropeties_selectLabel my-4 font-normal' id='deviceResolutionLabel'>
                                    Device Modal
                                </div>
                                <Select
                                    className='element h-10 w-full rounded-md text-black font-normal'
                                    style={{color:"black"}}
                                    onChange={setDeviceModal}
                                    placeholder='Device Resolution'
                                    id='deviceResolution'
                                    value={deviceModal}
                                    dropdownClassName='custom-dropdown'
                                >
                                    {Devices[deviceType] && Devices[deviceType].map((item, index) => (
                                        <Option
                                            title={item.resolution}
                                            key={`${item.resolution}_${index}`}
                                            value={item.resolution}
                                            className='custom-option'
                                        >
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        </div>
                    </div>
                </Form.Item>
            </Form>
        </Modal>
    );
};
